// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Stat grid */
.ann__stats-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}
.ann__stat-card {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.ann__stat-card--green .ann__stat-icon {
  position: relative;
}
.ann__green-dot {
  width: 0.7rem;
  height: 0.7rem;
  background: var(--admin-green);
  border-radius: 50%;
  display: block;
}
.ann__stat-icon-row {
  margin-bottom: 0.25rem;
}
.ann__stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ann__stat-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--admin-muted);
  margin: 0;
}
.ann__stat-value {
  font-family: var(--font-body);
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
  line-height: 1;
}
.ann__stat-value--green {
  color: var(--admin-green);
}
.ann__stat-link {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--admin-rust);
  padding: 0;
  text-align: left;
  transition: opacity 0.15s;
}
.ann__stat-link:hover {
  opacity: 0.75;
}

/* Layout */
.ann__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
.ann__layout--detail {
  grid-template-columns: 1fr 360px;
  align-items: start;
}

/* Filters */
.ann__filters {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}
.ann__filters-right {
  margin-left: auto;
}

/* List */
.ann__list-card {
  padding: 0;
  overflow: hidden;
}
.ann__empty {
  text-align: center;
  padding: 3rem;
  color: var(--admin-muted);
  font-size: 0.88rem;
  margin: 0;
}

.ann__item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid #f0ebe4;
  cursor: pointer;
  transition: background 0.12s;
  position: relative;
}
.ann__item:last-of-type {
  border-bottom: none;
}
.ann__item:hover {
  background: #faf7f2;
}
.ann__item--unread {
  background: rgba(var(--admin-rust-rgb), 0.025);
}
.ann__item--selected {
  background: rgba(var(--admin-rust-rgb), 0.05) !important;
}

.ann__unread-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  background: transparent;
  flex-shrink: 0;
}
.ann__unread-dot--active {
  background: var(--admin-rust);
}

.ann__item-icon {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ann__item-body {
  flex: 1 1;
  min-width: 0;
}
.ann__item-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.15rem;
}
.ann__item-desc {
  font-size: 0.78rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ann__item-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
  flex-shrink: 0;
}
.ann__item-time {
  font-size: 0.68rem;
  color: var(--admin-muted);
  white-space: nowrap;
}
.ann__item-more {
  padding: 0.2rem;
  font-size: 1rem;
  flex-shrink: 0;
}

/* Type badges */
.ann__type-badge {
  display: inline-flex;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.18rem 0.55rem;
  border-radius: 99px;
  white-space: nowrap;
}
.ann__type--app {
  background: rgba(var(--admin-rust-rgb), 0.1);
  color: var(--admin-rust);
}
.ann__type--sub {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}
.ann__type--don {
  background: rgba(124, 58, 237, 0.1);
  color: #7c3aed;
}

/* Detail panel */
.ann__detail {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  overflow: hidden;
  position: sticky;
  top: calc(var(--admin-topbar-h)+1rem);
}
.ann__detail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.ann__detail-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.ann__detail-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: var(--admin-muted);
  padding: 0.2rem;
  border-radius: 4px;
}
.ann__detail-close:hover {
  background: #f3f4f0;
}

.ann__detail-body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ann__detail-icon-row {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.ann__detail-type-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ann__detail-notif-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.3rem;
}
.ann__detail-read-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.2rem;
}
.ann__read-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
}
.ann__read-dot--unread {
  background: var(--admin-rust);
}
.ann__read-dot--read {
  background: var(--admin-green);
}
.ann__read-label {
  font-size: 0.75rem;
  color: var(--admin-muted);
}
.ann__detail-date {
  font-size: 0.72rem;
  color: var(--admin-muted);
  margin: 0;
}

.ann__detail-section {
  padding: 0.85rem 0;
  border-top: 1px solid var(--admin-border);
}
.ann__detail-section:first-child {
  border-top: none;
}
.ann__detail-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.5rem;
}
.ann__detail-message {
  font-size: 0.84rem;
  color: var(--admin-muted);
  margin: 0;
  line-height: 1.55;
}

.ann__detail-rows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.ann__detail-row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
}
.ann__detail-row span:first-child {
  font-size: 0.78rem;
  color: var(--admin-muted);
}
.ann__detail-row span:last-child {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--admin-text);
  text-align: right;
}

.ann__detail-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.ann__action-btn {
  width: 100%;
}
.ann__delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.65rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--admin-red);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.ann__delete-btn:hover {
  background: rgba(220, 38, 38, 0.06);
}

@media (max-width: 1199px) {
  .ann__stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .ann__layout--detail {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .ann__stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ── Toast feedback ── */
.ann__toast {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(22,163,74,0.1);
  border: 1px solid rgba(22,163,74,0.3);
  border-radius: 8px;
  padding: 0.65rem 1rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #16a34a;
  animation: slideDown 0.25s ease;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminNotifications.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["/* Stat grid */\n.ann__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1rem;\n}\n.ann__stat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n.ann__stat-card--green .ann__stat-icon {\n  position: relative;\n}\n.ann__green-dot {\n  width: 0.7rem;\n  height: 0.7rem;\n  background: var(--admin-green);\n  border-radius: 50%;\n  display: block;\n}\n.ann__stat-icon-row {\n  margin-bottom: 0.25rem;\n}\n.ann__stat-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ann__stat-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.ann__stat-value {\n  font-family: var(--font-body);\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n  line-height: 1;\n}\n.ann__stat-value--green {\n  color: var(--admin-green);\n}\n.ann__stat-link {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--admin-rust);\n  padding: 0;\n  text-align: left;\n  transition: opacity 0.15s;\n}\n.ann__stat-link:hover {\n  opacity: 0.75;\n}\n\n/* Layout */\n.ann__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n.ann__layout--detail {\n  grid-template-columns: 1fr 360px;\n  align-items: start;\n}\n\n/* Filters */\n.ann__filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n.ann__filters-right {\n  margin-left: auto;\n}\n\n/* List */\n.ann__list-card {\n  padding: 0;\n  overflow: hidden;\n}\n.ann__empty {\n  text-align: center;\n  padding: 3rem;\n  color: var(--admin-muted);\n  font-size: 0.88rem;\n  margin: 0;\n}\n\n.ann__item {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.9rem 1.1rem;\n  border-bottom: 1px solid #f0ebe4;\n  cursor: pointer;\n  transition: background 0.12s;\n  position: relative;\n}\n.ann__item:last-of-type {\n  border-bottom: none;\n}\n.ann__item:hover {\n  background: #faf7f2;\n}\n.ann__item--unread {\n  background: rgba(var(--admin-rust-rgb), 0.025);\n}\n.ann__item--selected {\n  background: rgba(var(--admin-rust-rgb), 0.05) !important;\n}\n\n.ann__unread-dot {\n  width: 0.55rem;\n  height: 0.55rem;\n  border-radius: 50%;\n  background: transparent;\n  flex-shrink: 0;\n}\n.ann__unread-dot--active {\n  background: var(--admin-rust);\n}\n\n.ann__item-icon {\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.ann__item-body {\n  flex: 1;\n  min-width: 0;\n}\n.ann__item-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.15rem;\n}\n.ann__item-desc {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ann__item-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.3rem;\n  flex-shrink: 0;\n}\n.ann__item-time {\n  font-size: 0.68rem;\n  color: var(--admin-muted);\n  white-space: nowrap;\n}\n.ann__item-more {\n  padding: 0.2rem;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n/* Type badges */\n.ann__type-badge {\n  display: inline-flex;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 0.18rem 0.55rem;\n  border-radius: 99px;\n  white-space: nowrap;\n}\n.ann__type--app {\n  background: rgba(var(--admin-rust-rgb), 0.1);\n  color: var(--admin-rust);\n}\n.ann__type--sub {\n  background: rgba(22, 163, 74, 0.1);\n  color: #16a34a;\n}\n.ann__type--don {\n  background: rgba(124, 58, 237, 0.1);\n  color: #7c3aed;\n}\n\n/* Detail panel */\n.ann__detail {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  overflow: hidden;\n  position: sticky;\n  top: calc(var(--admin-topbar-h)+1rem);\n}\n.ann__detail-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.ann__detail-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.ann__detail-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: var(--admin-muted);\n  padding: 0.2rem;\n  border-radius: 4px;\n}\n.ann__detail-close:hover {\n  background: #f3f4f0;\n}\n\n.ann__detail-body {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.ann__detail-icon-row {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n.ann__detail-type-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.ann__detail-notif-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.3rem;\n}\n.ann__detail-read-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.2rem;\n}\n.ann__read-dot {\n  width: 0.55rem;\n  height: 0.55rem;\n  border-radius: 50%;\n}\n.ann__read-dot--unread {\n  background: var(--admin-rust);\n}\n.ann__read-dot--read {\n  background: var(--admin-green);\n}\n.ann__read-label {\n  font-size: 0.75rem;\n  color: var(--admin-muted);\n}\n.ann__detail-date {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n\n.ann__detail-section {\n  padding: 0.85rem 0;\n  border-top: 1px solid var(--admin-border);\n}\n.ann__detail-section:first-child {\n  border-top: none;\n}\n.ann__detail-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.5rem;\n}\n.ann__detail-message {\n  font-size: 0.84rem;\n  color: var(--admin-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n\n.ann__detail-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.ann__detail-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n.ann__detail-row span:first-child {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n}\n.ann__detail-row span:last-child {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  text-align: right;\n}\n\n.ann__detail-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.ann__action-btn {\n  width: 100%;\n}\n.ann__delete-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.65rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--admin-red);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.ann__delete-btn:hover {\n  background: rgba(220, 38, 38, 0.06);\n}\n\n@media (max-width: 1199px) {\n  .ann__stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .ann__layout--detail {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 767px) {\n  .ann__stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* ── Toast feedback ── */\n.ann__toast {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(22,163,74,0.1);\n  border: 1px solid rgba(22,163,74,0.3);\n  border-radius: 8px;\n  padding: 0.65rem 1rem;\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #16a34a;\n  animation: slideDown 0.25s ease;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
